import { render, staticRenderFns } from "./ShiftLimitFields.vue?vue&type=template&id=0097a834"
import script from "./ShiftLimitFields.vue?vue&type=script&lang=js"
export * from "./ShiftLimitFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports